import { render, staticRenderFns } from "./switchboxs.vue?vue&type=template&id=444f8916&scoped=true&"
import script from "./switchboxs.vue?vue&type=script&lang=js&"
export * from "./switchboxs.vue?vue&type=script&lang=js&"
import style0 from "./switchboxs.vue?vue&type=style&index=0&id=444f8916&prod&lang=scss&scoped=true&"
import style1 from "./switchboxs.vue?vue&type=style&index=1&id=444f8916&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444f8916",
  null
  
)

export default component.exports